import { useCallback } from 'react'
import { useExport } from './useExport'
import {
  createBulkCommitmentLetters,
  getCommitmentLetterExport,
  type BulkCommitmentLetterGenerateRequest,
} from '@/api/commitmentLetters'

/**
 * Hook to export commitment letters for several plans in one zip
 * (one folder per plan). Uses the generic useExport hook.
 */
export function useBulkCommitmentLetterExport() {
  const createFn = useCallback(
    (request?: BulkCommitmentLetterGenerateRequest) =>
      createBulkCommitmentLetters(request!),
    []
  )

  const getFn = useCallback(
    (exportId: string) => getCommitmentLetterExport(exportId),
    []
  )

  const exportHook = useExport<BulkCommitmentLetterGenerateRequest>({
    createExportFn: createFn,
    getExportFn: getFn,
    filenamePrefix: 'commitment-letters',
    fileExtension: 'zip',
  })

  return { ...exportHook, exportBulkCommitmentLetters: exportHook.startExport }
}
